import axios from 'axios'

const state = {
  modificationsList: [],
  modificationsSingle: null,
}

const getters = {
  getModificationsList (state) {
    return state.modificationsList
  },
  getModificationsSingle (state) {
    return state.modificationsSingle
  },
}

const mutations = {
  setModificationsList (state, payload) {
    state.modificationsList = payload
  },
  setModificationsSingle (state, payload) {
    state.modificationsSingle = payload
  },
  clearSingleModifications (state) {
    state.modificationsSingle = null
  },
}

const actions = {
  fetchModificationsList ({ commit, rootGetters }, meta) {
    return axios
      .get(
        `${rootGetters['api/modificationsList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        commit('setModificationsList', res.data.items)

        return res
      })
      .catch((err) => err)
  },
  fetchSingleModifications ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/modificationsSingle'](id))
      .then((res) => {
        commit('setModificationsSingle', res.data.data)

        return res
      })
      .catch((err) => err)
  },
  createModifications ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/modificationsCreate'], data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  editModifications ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/modificationsEdit'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  deleteModifications ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/modificationsDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.modificationsList.filter((val) => val.id !== id)
          commit('setModificationsList', items)
        }

        return res
      })
      .catch((err) => err)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
